import React, { useEffect, useRef } from "react";
// Import file nhạc của bạn ở đây
import bgMusic from "../assets/audio/Ordinary_Violin_Wedding _Version_Alex_Warren_Cover.mp3"; 

const MusicPlayer = () => {
  const audioRef = useRef(null);
  const isAttemptingPlay = useRef(false); // Cờ để ngăn gọi play() chồng chéo
  
  // Thời điểm muốn cắt nhạc (3 phút 35 giây = 215 giây)
  const END_TIME = 215; 

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    // 1. Thiết lập âm lượng
    audio.volume = 0.4;

    // 2. Logic cắt nhạc: Kiểm tra liên tục, nếu vượt quá 3:35 thì quay về 0
    const handleTimeUpdate = () => {
      if (audio.currentTime >= END_TIME) {
        audio.currentTime = 0;
        audio.play().catch(() => {}); // Catch lỗi nếu play bị chặn khi loop
      }
    };

    audio.addEventListener("timeupdate", handleTimeUpdate);

    // Danh sách các sự kiện tương tác cần lắng nghe
    // Thêm 'wheel' để bắt sự kiện lăn chuột trên desktop nhạy hơn
    const events = ["click", "mousedown", "keydown", "touchstart", "scroll", "wheel"];

    // Hàm xóa lắng nghe sự kiện (chỉ gọi khi đã play thành công)
    const removeInteractionListeners = () => {
      events.forEach((event) => {
        document.removeEventListener(event, handleInteraction);
      });
    };

    // 3. Hàm xử lý tương tác: Chỉ xóa listener nếu play thành công
    const handleInteraction = () => {
      // Nếu đang phát rồi hoặc đang trong quá trình thử phát thì return ngay
      if (!audio.paused || isAttemptingPlay.current) {
        if (!audio.paused) removeInteractionListeners();
        return;
      }

      isAttemptingPlay.current = true; // Đánh dấu đang thử phát
      const playPromise = audio.play();
      
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Play thành công -> Xóa sự kiện để không gọi lại thừa thãi
            removeInteractionListeners();
          })
          .catch((error) => {
            // Play thất bại -> Reset cờ để thử lại ở lần cuộn tiếp theo
            isAttemptingPlay.current = false;
          });
      }
    };

    // 4. Thử phát ngay lập tức khi vào trang (cho những trình duyệt cho phép)
    handleInteraction();

    // 5. Gắn sự kiện lắng nghe
    // Thêm { passive: true } để không làm chậm thao tác cuộn trang
    events.forEach((event) => {
      document.addEventListener(event, handleInteraction, { passive: true });
    });

    return () => {
      // Cleanup khi unmount
      audio.removeEventListener("timeupdate", handleTimeUpdate);
      removeInteractionListeners();
    };
  }, []);

  return (
    // Thêm thuộc tính autoPlay để trình duyệt ưu tiên phát ngay nếu chính sách cho phép
    <audio ref={audioRef} src={bgMusic} hidden autoPlay />
  );
};

export default MusicPlayer;